<template>
  <header class="header">
    <div class="header-l">
      <router-link :to="{name:'home'}" class="logo"></router-link>
      <ul class="nav clearfix">
        <li>
          <router-link :to="{name:'invest'}">{{$t('nav.w1')}}</router-link>
        </li>
        <li>
          <router-link :to="{name:'borrow'}">{{$t('nav.w2')}}</router-link>
        </li>
      </ul>
    </div>
    <div class="header-r">
      <Loginstate/>
    </div>
  </header>
</template>

<script>
import Loginstate from './loginstate.vue'
export default {
    components:{
      Loginstate
    }
}
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 5px #F2F2F2;
  .header-l {
    float: left;
    .logo {
      display: block;
      width: 146px;
      height: 56px;
      float: left;
      background-image: url("../assets/logo.jpg");
      background-size:cover;
      background-repeat: no-repeat;
      margin: 12px 0px 12px 50px;
    }
    .nav {
      float: right;
      margin-left: 71px;
      li {
        cursor: pointer;
        float: left;
        text-align: center;
        height: 80px;
        width: 120px;
        text-align: center;
        box-sizing: border-box;
        a {
          display: inline-block;
          width: 100%;
          height: 80px;
          line-height: 80px;
          font-size: 18px;
          color: rgba(35, 35, 37, 1);
          text-decoration: none;
          &:focus {
            outline: 0;
          }
        }
         .router-link-exact-active{
            background:linear-gradient(180deg,rgba(222,238,255,1) 0%,rgba(247,251,255,1) 100%);
            position: relative;
            &::before{
              content: '';
              width:120px;
              height:4px;
              background:linear-gradient(270deg,rgba(136,173,254,1) 0%,rgba(80,123,252,1) 100%);
              border-radius:4px;
              position: absolute;
              left: 0px;
              bottom: 0px;
            }
          }
      }
      
    }
  }
  .header-r {
    float: right;
    height: 100%;
  }
}
</style>


